var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oeos-overlay",attrs:{"id":'oeos-overlay--' + _vm.id}},[_c('div',{ref:"rootElement"})])}
var staticRenderFns = []

export { render, staticRenderFns }